import { ErrorBoundary } from "react-error-boundary";
import { AppComOuSemLogin } from "@/components/app/ModoLocalSemLogin";
import { AppVersionMonitor } from "@/components/app/AppVersionMonitor";
import { AppCrashFallback } from "@/components/app/AppCrashFallback";
import { InstalarApp } from "@/components/app/InstalarApp";
import { isStaleChunkError, reloadForNewBuild } from "@/components/app/staleChunkRecovery";

/**
 * Application entry point
 *
 * Customize Atomic CRM by passing props to the CRM component:
 *  - contactGender
 *  - companySectors
 *  - darkTheme
 *  - dealCategories
 *  - dealPipelineStatuses
 *  - dealStages
 *  - lightTheme
 *  - logo
 *  - noteStatuses
 *  - taskTypes
 *  - title
 * ... as well as all the props accepted by shadcn-admin-kit's <Admin> component.
 *
 * @example
 * const App = () => (
 *    <CRM
 *       logo="./img/logo.png"
 *       title="Acme CRM"
 *    />
 * );
 */
const App = () => (
	<>
		<AppVersionMonitor />
		<InstalarApp />
		{/* Se o CRM cair, o monitor de versão continua vivo e o usuário vê um
		    botão de recarregar em vez de tela branca. Erro de build velho
		    recarrega sozinho. */}
		<ErrorBoundary
			FallbackComponent={AppCrashFallback}
			onError={(error) => {
				if (isStaleChunkError(error)) reloadForNewBuild();
			}}
		>
			{/* Em produção isto é o <CRM /> e nada mais; o modo local sem
			    login só existe no build de desenvolvimento. */}
			<AppComOuSemLogin />
		</ErrorBoundary>
	</>
);

export default App;
